import React, { Dispatch, useState } from 'react';
import { Button, Tooltip, Spin } from 'antd';
import { ColumnType } from 'antd/lib/table';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { InfoCircleOutlined, PrinterOutlined } from '@ant-design/icons';
import TitlePage from '../../components/TitlePage';
import Filter from './components/Filter';
import DrawerEstoque from './components/Drawer';
import { useWindowSize } from '../../hook/useWindowSize';
import { Container } from './styles';
import { Action } from 'typesafe-actions';
import { loadRequest, sorterEstoque } from '../../store/ducks/estoque/actions';
import TableSec from './components/TableSec';
import { Sorter, sorterParamsHandle } from '../../utils/sorte';
import TableSort from '../../components/TableSort';
import api from '../../service/api';
import { saveAs } from 'file-saver';
import CardMobile from '../estoque/components/CardMobile';
import AnchorButton from '../../components/AnchorButton';
import { HandleClickRowActive } from '../../utils/handleclickrowactive';
import { SKW_PREFIX } from '../../utils/constants';
import mask from '../../utils/mask';
import { Group } from './types';
import TextTable from '../../components/TextTable';
import Refresh from '../../components/Refresh';

const ContentEstoque: React.FC = () => {
  const loading = useSelector((state: ApplicationState) => state.Estoque.loading);
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);
  const estoque = useSelector((state: ApplicationState) => state.Estoque.data);
  const filter = useSelector((state: ApplicationState) => state.Estoque.filter);
  const pagination = useSelector((state: ApplicationState) => state.Estoque.pagination);
  const dispatch = useDispatch<Dispatch<Action>>();
  const [exportLoading, setexportLoading] = useState(false);
  const { width }: any = useWindowSize();

  const handlePdf = async () => {
    try {
      setexportLoading(true);
      await api
        .post(
          `/call?serviceName=${SKW_PREFIX}imprimeDetalheEstoque&token=${token}`,
          {
            inscricoesEstaduais: inscricaoAtiva,
            centroDistribuicao: cddAtivo?.codCdd,
          },
          {
            responseType: 'arraybuffer',
          }
        )
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          saveAs(blob, `estoque-detalhado.xls`);
        });
    } catch (error) {
    } finally {
      setexportLoading(false);
    }
  };

  const columns: ColumnType<Group>[] = [
    {
      title: 'Código interno',
      dataIndex: 'codProduto',
      key: 'codProduto',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 1,
      },
      render: (text: string) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable> Não informado </TextTable>;
      },
    },
    {
      title: 'Código referência',
      dataIndex: 'codReferencia',
      key: 'codReferencia',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 2,
      },
      render: (text: string) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable> Não informado </TextTable>;
      },
    },
    {
      title: 'Produto',
      dataIndex: 'descricaoProduto',
      key: 'descricaoProduto',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 5,
      },
      render: (text: string) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable> Não informado </TextTable>
        );
      },
    },
    {
      title: 'Nota fiscal',
      dataIndex: 'notas',
      key: 'notas',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 2,
      },
      render: (text: string) => {
        return text
          ? <TextTable>
            <div className='hidden'>
              <Tooltip title={text}>
                {text}
              </Tooltip>
            </div></TextTable>
          : <TextTable> Não informado </TextTable>;
      },
    },
    {
      title: 'Inscrição estadual',
      dataIndex: 'inscricaoEstadualParceiro',
      key: 'inscricaoEstadualParceiro',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 3,
      },
      render: (text: string) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable> Não informado </TextTable>;
      },
    },
    {
      title: 'Depositante',
      dataIndex: 'parceiro',
      key: 'parceiro',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 4,
      },
      render: (text: string) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable> Não informado </TextTable>
        );
      },
    },

    {
      title: 'UN',
      dataIndex: 'unidade',
      key: 'unidade',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 6,
      },
      render: (text: string) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable> Não informado </TextTable>
        );
      },
    },

    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 7,
      },
      render: (text: string) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable> Não informado </TextTable>;
      },
    },
  ];

  return (
    <>
      <Refresh
        loadRequest={() =>
          dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd, pagination))
        }
      />
      <Filter />

      <Container>
        <TitlePage>
          <span>
            <AnchorButton textRoute={'estoque'} />
            Estoque
            {perfil === 'F' ? (
              <Tooltip
                placement="topLeft"
                title={
                  'Alguns produtos só poderão ser solicitados entrando em contato com o armazém'
                }
              >
                <InfoCircleOutlined style={{ fontSize: '13px', paddingLeft: '5px' }} />
              </Tooltip>
            ) : (
              ''
            )}
          </span>

          <div className="box">
            <Button
              onClick={() => handlePdf()}
              type="text"
              className="primary"
              disabled={exportLoading}
              icon={exportLoading ? <Spin size="small" /> : <PrinterOutlined />}
            >
              Estoque detalhado
            </Button>
            <DrawerEstoque />
          </div>
        </TitlePage>
        {width > 768 && (
          <TableSort
            columns={columns}
            size="large"
            className="table"
            style={{ fontSize: 10, display: 'inline' }}
            scroll={{ x: 1400 }}
            rowKey={(r: any) => r.codProduto + r.inscricaoEstadualParceiro}
            dataSource={estoque}
            loading={loading === true ? true : false}
            onChange={(pagination: any, filters: any, sorter: any) => {
              dispatch(
                loadRequest(
                  filter,
                  filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
                  cddAtivo?.codCdd,
                  pagination,
                  sorterParamsHandle(sorter)
                )
              );
              dispatch(sorterEstoque(sorterParamsHandle(sorter)));
            }}
            onRow={(record: any, rowIndex: any) => {
              return {
                onClick: (event: React.MouseEvent<HTMLElement>) =>
                  HandleClickRowActive(event, record),
              };
            }}
            pagination={pagination}
            expandable={{
              expandedRowRender: (record: any) => <TableSec record={record} />,
            }}
          />
        )}
        {width <= 768 && (
          <>
            <CardMobile
              props={estoque}
              pagination={pagination}
              loading={loading}
              inscricaoAtiva={inscricaoAtiva}
              cddAtivo={cddAtivo}
              filter={filter}
            />
          </>
        )}
      </Container>
    </>
  );
};

export default ContentEstoque;
